export const setHeightOfTable = (itemsPerPage: number, height?: number): number => {
	if (height) return itemsPerPage * height + (height - 20);
	return itemsPerPage < 5 ? 350 : itemsPerPage * 72 + 50;
};
